import { render, staticRenderFns } from "./settlementReturn.vue?vue&type=template&id=28a2342c&scoped=true&"
import script from "./settlementReturn.vue?vue&type=script&lang=js&"
export * from "./settlementReturn.vue?vue&type=script&lang=js&"
import style0 from "./settlementReturn.vue?vue&type=style&index=0&id=28a2342c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2342c",
  null
  
)

export default component.exports